/**
 * The query-param mechanism behind "Develop it lands on the promise" (UX polish wave 2
 * decision 6): a tenant with no projects yet who clicks Home's "Develop it" card creates a
 * project (`CreateProjectModal`'s `postCreateHref`) and lands straight on its Sessions tab
 * with the develop launcher (`StartDevelopDialog`) already open, rather than an empty tab
 * they'd have to know to act on. `ProjectSessionsTab` is the one place that reads this —
 * consumed at most once so navigating away
 * and back never re-opens the dialog on its own.
 */
export const LAUNCH_DEVELOP_PARAM = "launch";
export const LAUNCH_DEVELOP_VALUE = "develop";

/** Builds the Sessions-tab href that auto-opens the develop launcher for a freshly created
 * project — the one call site is `CreateProjectModal`'s `postCreateHref` from `HomePage`. */
export function sessionsWithDevelopLaunchHref(projectId: string): string {
  return `/projects/${projectId}/sessions?${LAUNCH_DEVELOP_PARAM}=${LAUNCH_DEVELOP_VALUE}`;
}

/** Whether the current URL asked for the develop launcher to open automatically —
 * `window.location.search`, matching `SSOErrorPage`'s existing precedent for reading a
 * one-off query param (wouter's router here carries no query-string API of its own). */
export function shouldAutoLaunchDevelop(): boolean {
  return new URLSearchParams(window.location.search).get(LAUNCH_DEVELOP_PARAM) === LAUNCH_DEVELOP_VALUE;
}
